import axios from 'axios'
import {useState} from 'react'
import {Button} from 'react-bootstrap-v5'
import {toast} from 'react-toastify'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

// Backend setting that turns on the legacy Siddhartha "complete shortlisting" (API: apply-vacancy/complete-shortlisting)
export const COMPLETE_SHORTLISTING_SETTING = 'careerCompleteShortlisting'

// The stage's status system name -> the rejected status everyone left at it gets ("X Rejected" = not advanced to X)
const REJECTED_FOR: Record<string, string> = {
  pending: 'Exam Rejected',
  shortlisted: 'Group Discussion Rejected',
  shortlisted_for_group_discussion: 'Interview Rejected',
  shortlisted_for_interview: 'Job Rejected',
}

// Per-stage rejected lists for the status filter of the candidates list
export const REJECTED_STATUSES = [
  {value: 'exam_rejected', label: 'Exam Rejected'},
  {value: 'group_discussion_rejected', label: 'Group Discussion Rejected'},
  {value: 'interview_rejected', label: 'Interview Rejected'},
  {value: 'job_rejected', label: 'Job Rejected'},
]

interface Props {
  vacancyId: string
  stage: keyof typeof REJECTED_FOR
  onDone: () => void
}

// "Complete Shortlisting" button of a stage list; renders nothing unless the bank turned the setting on
const CompleteShortlisting = ({vacancyId, stage, onDone}: Props) => {
  const enabled = checkBackendSetting(COMPLETE_SHORTLISTING_SETTING)
  const [busy, setBusy] = useState(false)
  if (!enabled) return null

  const complete = () => {
    if (!confirm(`Everyone still at this stage will be marked "${REJECTED_FOR[stage]}" and emailed, and the vacancy stops taking applications. Continue?`)) return
    setBusy(true)
    axios
      .post(API_URL + '/apply-vacancy/complete-shortlisting', {vacancyId, stage})
      .then((res) => {
        toast.success(res.data?.data?.message || 'Shortlisting completed.')
        onDone()
      })
      .catch((err) => toast.error(err?.response?.data?.message || 'Could not complete shortlisting.'))
      .finally(() => setBusy(false))
  }

  return (
    <Button variant='danger' size='sm' className='mb-3' disabled={busy} onClick={complete} data-cy='complete-shortlisting'>
      Complete Shortlisting
    </Button>
  )
}

// Status filter of the candidates list (screening inbox by default, or one of the per-stage rejected lists)
export const RejectedStatusFilter = ({value, onChange}: {value: string; onChange: (status: string) => void}) => {
  const enabled = checkBackendSetting(COMPLETE_SHORTLISTING_SETTING)
  if (!enabled) return null
  return (
    <select
      className='form-select form-select-sm mb-3 me-3 d-inline-block w-auto'
      aria-label='Status'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-cy='rejected-status-filter'
    >
      <option value=''>Screening (default)</option>
      {REJECTED_STATUSES.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))}
    </select>
  )
}

export default CompleteShortlisting
